<template>
    <div>
      <nav-bar></nav-bar>
      <div id="productDetail" class="container-fluid has-action-bar bg-music pt-16" v-if="isDataLoaded">

        <div class="container round10px p-3 mx-auto my-3">
          <div class="row align-items-center justify-content-center dark-bg round10px pt-5 pb-5">
            <div class="col-md-8 col-12 text-right">
              <h3 class="text-align mb-5 secondary-text">
                {{ allProject.title}}
              </h3>
              <h5 class="text-align mb-2">
                {{ allProject.summary}}
              </h5>
              <span class="text-align">
                        {{ allProject.desc}}
                    </span>
              <div class="mt-6 winter">
                <a :href="allProject.url" class="light-text" target="_blank">

                  <v-btn
                      color="wintercolor"
                      class="d-flex flex-row align-items-center">
                    <span class="white--text"> مشاهده </span> <i class="fas fa-eye white--text  mr-1"></i>
                  </v-btn>

                </a>
              </div>
              <div class="mt-6 autumn">
                <a :href="allProject.url" class="light-text" target="_blank">

                  <v-btn
                      color="autumncolor"
                      class="d-flex flex-row align-items-center">
                    <span class="white--text"> مشاهده </span> <i class="fas fa-eye white--text  mr-1"></i>
                  </v-btn>

                </a>
              </div>
              <div class="mt-6 spring">
                <a :href="allProject.url" class="light-text" target="_blank">

                  <v-btn
                      color="springcolor"
                      class="d-flex flex-row align-items-center">
                    <span class="white--text"> مشاهده </span> <i class="fas fa-eye white--text  mr-1"></i>
                  </v-btn>

                </a>
              </div>
              <div class="mt-6 summer">
                <a :href="allProject.url" class="light-text" target="_blank">

                  <v-btn
                      color="summercolor"
                      class="d-flex flex-row align-items-center">
                    <span class="white--text"> مشاهده </span> <i class="fas fa-eye white--text  mr-1"></i>
                  </v-btn>

                </a>
              </div>

              <!--<div class="mt-5 light-text"><span>آدرس سایت: <a :href="allProject.url" class="light-text" target="_blank">
                  {{allProject.url.replace("https://", "").replace("http://www.", "")}}</a> </span></div>-->
            </div>
            <div class="col-md-4 col-12">
              <img

                  :src="getImgUrl('allProject/'+ allProject.imageRoot + '/main.jpg')"
                   :alt="allProject.title"
                   class="img-fluid">
            </div>
            <div class="col-12" dir="ltr">
              <div class="row">
                <div class="col-md-3" v-for="(image, i) in images" :key="i">
                  <img class="image img-fluid "
                       :alt="allProject.title"
                       :src="image"
                       @click="index = i">
                  <vue-gallery-slideshow
                      :images="images"
                      :index="index"
                      @close="index = null">
                  </vue-gallery-slideshow>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    <footer-pages></footer-pages>
    </div>
</template>

<script>

    import VueGallerySlideshow from 'vue-gallery-slideshow';
    import NavBar from "@/components/NavBar";
    import FooterPages from "@/components/FooterPages";


    export default {
        name: "AllProductDetail",
        metaInfo: {
            title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-جزیات سایت'
        },
        components: {
          FooterPages,
          NavBar,

            VueGallerySlideshow
        },
        data: () => ({
            images: [],
            index: null,
            title: null,
            hasData: true,
            products: [],
            allProject: {},
            isDataLoaded: false,
        }),
        mounted() {
          this.$setCssFiles();
            this.initData();
            this.$scrollTop(0)
        },
        methods: {
            getImgUrl(pic) {
                return require('../assets/img/' + pic);
            },

            initData() {
                this.products = this.$getAllProjects();
                let id = this.$route.query.AllProductID;

                for (let i = 0; i < this.products.length; i++) {
                    if (this.products[i].id.toString() === id) {

                        this.allProject = this.products[i];
                        let tempGallery = [];
                        for (let j = 0; j < this.products[i].gallery.length; j++) {
                            tempGallery.push(this.getImgUrl(
                                'allProject/' + this.allProject.imageRoot + '/' + this.products[i].gallery[j]));
                        }
                        this.images = tempGallery;
                        this.isDataLoaded = true;
                        break;
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
